let headerEstimateFormButton = $('.header-button'),
    footerEstimateFormButton = $('.footer-button'),
    heroEstimateFormButton = $('.hero-button'),
    fullScreenMenuEstimateFormButton = $('.full-screen-menu__button'),
    ctaButton = $('.cta-block__button-white'),
    ourTeamButton = $('.our-team__button-green'),
    popupSlideButton = $('.insects-popup-slide__button'),
    servicePlansButton = $('.service-plans-block__button'),
    freeEstimateFormWrapper = $('.estimate-form'),
    estimateFormButtons = { headerEstimateFormButton, footerEstimateFormButton, heroEstimateFormButton, fullScreenMenuEstimateFormButton, ctaButton, ourTeamButton, popupSlideButton, servicePlansButton },
    closeButton = $('.estimate-form__close');

$.each(estimateFormButtons, function () {
    $(this).on('click', function () {
        $('body').addClass('fix');
        freeEstimateFormWrapper.fadeIn();
        $('select.estimate-form-select').minimalect();
        $('.estimate-form-submit').prop('disabled', true);
        customValidation();
    });
});
freeEstimateFormWrapper.on('click', function (e) {
    if ($(e.target).is(this)) {
        if (!$('.full-screen-menu').is(':visible') && !$('.protect-against__popup').is(':visible')) {
            $('body').removeClass('fix');
        }
        freeEstimateFormWrapper.fadeOut();
    }
});
closeButton.on('click', function () {
    if (!$('.full-screen-menu').is(':visible') && !$('.protect-against__popup').is(':visible')) {
        $('body').removeClass('fix');
    }
    freeEstimateFormWrapper.fadeOut();
});
$(document).on('click', '.thank-you-message__button', function () {
    if (!$('.full-screen-menu').is(':visible') && !$('.protect-against__popup').is(':visible')) {
        $('body').removeClass('fix');
    }
    freeEstimateFormWrapper.fadeOut();
});
$(document).on('nfFormReady', function () {
    $('.estimate-form-submit').prop('disabled', true);
    customValidation();
});

$(document).on('nfFormSubmitResponse', function () {
    $('.estimate-form-submit').prop('disabled', true);
    customValidation()
});
function customValidation() {
    let invalidZipcodeError = '<div class="nf-error-msg zipcode-error-message">Invalid Zipcode</div>',
        zipcodeList = themeVars['zipArray'].map(Number);
    $('.estimate-form select').on('change', function () {
        if ($(this).val().length !== 1 && $('#nf-field-61').val().length !== 0 && $('#nf-field-9').val().length !== 0 && $('#nf-field-10').val().length !== 0 && $('#nf-field-11').val().length !== 0 && $('#nf-field-12').val().length !== 0 && !$('#nf-field-61').hasClass('error')) {
            $('.estimate-form-submit').prop('disabled', false);
        } else {
            $('.estimate-form-submit').prop('disabled', true);
        }
    });
    $('#nf-field-9').on('input', function () {
        if ($(this).val().length !== 0 && $('#nf-field-61').val().length !== 0 && $('#nf-field-10').val().length !== 0 && $('#nf-field-11').val().length !== 0 && $('#nf-field-12').val().length !== 0 && $('.estimate-form select').val().length !== 1 && !$('#nf-field-61').hasClass('error')) {
            $('.estimate-form-submit').prop('disabled', false);
        } else {
            $('.estimate-form-submit').prop('disabled', true);
        }
    });
    $('#nf-field-10').on('input', function () {
        if ($(this).val().length !== 0 && $('#nf-field-61').val().length !== 0 && $('#nf-field-9').val().length !== 0 && $('#nf-field-11').val().length !== 0 && $('#nf-field-12').val().length !== 0 && $('.estimate-form select').val().length !== 1 && !$('#nf-field-61').hasClass('error')) {
            $('.estimate-form-submit').prop('disabled', false);
        } else {
            $('.estimate-form-submit').prop('disabled', true);
        }
    });

    $('#nf-field-11').on('input', function () {
        if ($(this).val().length !== 0 && $('#nf-field-61').val().length !== 0 && $('#nf-field-9').val().length !== 0 && $('#nf-field-10').val().length !== 0 && $('#nf-field-12').val().length !== 0 && $('.estimate-form select').val().length !== 1 && !$('#nf-field-61').hasClass('error')) {
            $('.estimate-form-submit').prop('disabled', false);
        } else {
            $('.estimate-form-submit').prop('disabled', true);
        }
    });
    $('#nf-field-12').on('keyup', function () {
        console.log($(this).val().length);
        if ($(this).val().indexOf("_") == -1 && $('#nf-field-61').val().length !== 0 && $('#nf-field-9').val().length !== 0 && $('#nf-field-10').val().length !== 0 && $('#nf-field-11').val().length !== 0 && $('.estimate-form select').val().length !== 1 && !$('#nf-field-61').hasClass('error')) {
            $('.estimate-form-submit').prop('disabled', false);
        } else {
            $('.estimate-form-submit').prop('disabled', true);
        }
    });

    $('select.estimate-form-select').minimalect();
    $('#nf-field-61').on('input', function () {
        if (zipcodeList.indexOf(parseInt($(this).val())) === -1) {
            $(this).css('cssText', 'border-color: #e80000 !important').addClass('error');
            $('.estimate-form-submit ').prop('disabled', true);
            $('.zip-container').find('.nf-error-wrap.nf-error').hasClass('zipcode-error') || $(this).val().length == 0 ? '' :
                $('.zip-container').find('.nf-error-wrap.nf-error').addClass('zipcode-error').append(invalidZipcodeError);
        } else {
            $(this).css('cssText', 'border-color: transparent').removeClass('error');
            $('.nf-error-wrap.nf-error').removeClass('zipcode-error');
            $('.zipcode-error-message').remove();
            if ($('.estimate-form input[type="text"]').val() !== 0 && $('.estimate-form input[type="email"]').val() !== 0 && $('.estimate-form select').val() !== ' ') {
                $('.estimate-form-submit').prop('disabled', false);
            }
        }
        if ($(this).val().length == 0) {
            $(this).css('cssText', 'border-color: transparent').removeClass('error');
            $('.nf-error-wrap.nf-error').removeClass('zipcode-error');
            $('.zipcode-error-message').remove();
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/modules/estimate-form.js